import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 5,
	height: 3,
	viewBox: "0 0 5 3",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 3.31558,
		height: .918116,
		transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0.64917 2.99368)",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		width: 3.31558,
		height: .918116,
		transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 4.6814 2.35077)",
		fill: "currentColor"
	})]
});
export default SvgCaretUp;
